import React from 'react';

const COPY = {
  en: {
    eyebrow: 'HOW WE HELP',
    title: 'A working process the team can see.',
    steps: [
      { n: '01', h: 'ILLUMINATE', body: 'Find the real problem and the strongest opportunity.' },
      { n: '02', h: 'SHAPE', body: 'Set the direction, scope, language, and experience.' },
      { n: '03', h: 'MAKE', body: 'Guide execution while protecting the core idea.' },
      { n: '04', h: 'RELEASE', body: 'Launch, learn from use, and improve what matters next.' },
    ],
  },
  es: {
    eyebrow: 'CÓMO AYUDAMOS',
    title: 'Un proceso de trabajo que el equipo puede ver.',
    steps: [
      { n: '01', h: 'ILUMINAR', body: 'Encontrar el problema real y la mejor oportunidad.' },
      { n: '02', h: 'DAR FORMA', body: 'Definir dirección, alcance, lenguaje y experiencia.' },
      { n: '03', h: 'HACER', body: 'Guiar la ejecución protegiendo la idea central.' },
      { n: '04', h: 'LANZAR', body: 'Lanzar, aprender del uso y mejorar lo siguiente que importa.' },
    ],
  },
};

const ProcessStripCompactV2 = ({ lang = 'en' }) => {
  const t = COPY[lang] || COPY.en;
  return (
    <section className="iv2-process-compact" data-testid="iv2-process-compact">
      <div className="iv2-container">
        <div className="iv2-process-compact-head">
          <p className="iv2-section-eyebrow">{t.eyebrow}</p>
          <h2 className="iv2-process-compact-title">{t.title}</h2>
        </div>
        <ol className="iv2-process-compact-list">
          {t.steps.map((step) => (
            <li key={step.n} className="iv2-process-compact-item">
              <span className="iv2-process-compact-n" aria-hidden="true">
                / {step.n}
              </span>
              <h3 className="iv2-process-compact-h">{step.h}</h3>
              <p className="iv2-process-compact-body">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ProcessStripCompactV2;
